import React from 'react';
import {FormattedDate} from "react-intl";
import PropTypes from 'prop-types';
import moment from "moment/moment";

import {capitalize} from "utils/capitalize";

import {greyishBlue400} from "assets/jss/main";

NotificationDate.propTypes = {
    notification: PropTypes.shape({
        createdAt: PropTypes.string
    })
};

function NotificationDate({notification = null}) {
   function formatDate(date) {
        if (date) {
            const millisecondsAgo = Math.abs(Date.now() - new Date(date));
            const minutesAgo = Math.floor(millisecondsAgo / 60000);
            const hoursAgo = Math.round(minutesAgo / 60);
            const daysAgo = Math.round(hoursAgo / 24);
            const relativeDate = capitalize(moment(date).fromNow());

            if (daysAgo > 1) {
                return (
                    <FormattedDate
                        value={new Date(date)}
                        year={"numeric"}
                        month={"numeric"}
                        day={"numeric"}
                    />
                )
            } else {
                return relativeDate
            }
        } else return "-"
   }

    return (
        <div style={{
            fontSize: '12px',
            color: greyishBlue400
        }}>
            {formatDate(notification.createdAt)}
        </div>
    )
}

export default NotificationDate;
